<div class="flow-input">
  <label><ng-content></ng-content></label>

  <div class="input-container">
    <input
      #inputElement
      autocapitalize="off"
      autocorrect="off"
      [class.icon]="icon !== ''"
      [disabled]="disabled"
      [maxLength]="maxLength"
      [placeholder]="placeholder"
      [readOnly]="readonly"
      [tabIndex]="tabindex"
      [type]="type"
      [(ngModel)]="value"
      (change)="handleChange($event)"
      (input)="handleInput($event)">
      @if (icon !== '') {
        <ion-icon [name]="icon" (click)="getFocus()"></ion-icon>
      }
    </div>
  </div>
